// extracted by mini-css-extract-plugin
module.exports = {"row":"_1hjLmF5RKF89AZ2vMprtft"};